import React, { Component } from "react";
import {Link} from "react-router-dom";
import { FiChevronDown } from 'react-icons/fi';
import InfiniteScroll from 'react-infinite-scroll-component';

import './ReturnOrders.scss';
import MyContext from '../MyContext.jsx';


class ReturnOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sale_returns : [],
      returnorder_id : '',
      ro_reason : '',
    }
    this.formChange = this.formChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.fetchReturnOrders = this.fetchReturnOrders.bind(this);
  }

  fetchReturnOrders(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getExeSaleReturns`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){ 
        obj_this.setState({sale_returns:return_data.salesreturns});
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  componentDidMount(){    
    var obj_this = this;
    
    obj_this.fetchReturnOrders();

    // $(".salesreturn_page_container").on("click",".so_approve_button",function(e){
    //   e.stopPropagation();
    //   if(!confirm("Do you want to confirm this order")){
    //     return;
    //   }
    //   const returnorder_id = $(this).attr("returnorder_id");
    //   const url = `${process.env.REACT_APP_SSS}/api/salesReturnApproval`;
    //   obj_this.context.loading(1);
    //   $.ajax({
    //     url : url,
    //     data : {
    //       sid : obj_this.context.user_details.sid,
    //       sales_return_id : returnorder_id
    //     },
    //     type : "POST"
    //   }).done(function(return_data){
    //       console.log(return_data);
    //     if(return_data.status == "success"){
    //       obj_this.setState({sale_returns:return_data.salesreturns},()=>{
    //         $(".salesreturn_page_container .single_so_container").css("height","60px").find(".arrow_down").css("transform","rotate(0deg)");
    //       });
    //       obj_this.context.loading(0);
    //       alert("Return order verified.")
    //     }else{
    //       obj_this.context.loading(0);
    //       obj_this.props.history.replace("/");
    //     }
    //   }).fail(function(){
    //     alert("Network error");
    //   });

    // });

    $(".salesreturn_page_container").on("click",".so_edit_button",function(e){
       e.stopPropagation();
       const returnorder_id = $(this).attr("returnorder_id");
       obj_this.props.history.push("/salesreturn/edit/"+returnorder_id);
    });

    $(".salesreturn_page_container").on("click",".single_so_container",function(){
      if($(this).outerHeight() == "75"){
        $(this).heightAuto();
        $(this).find(".arrow_down").css("transform","rotate(180deg)");
      }else{
        $(this).css("height","75px");
        $(this).find(".arrow_down").css("transform","rotate(0deg)");
      }
    });

    $(".salesreturn_page_container").on("click",".asm_reject_button",function(e){
      e.stopPropagation();
      obj_this.setState({
        returnorder_id: $(this).attr("returnorder_id")
      });
      $(".close_form_ghost").css("display","block");

    });

    $(".close_form_ghost .close_button").on("click",function(){
      $(".close_form_ghost").css("display","none");
      obj_this.setState({
        ro_reason: '',
        returnorder_id: ''
      });
    });


    ui.swipeMenu(".sales_orders_container");
  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  formSubmit(e){
    e.preventDefault();
    console.log(this.state);
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/salesReturnCancel`;
    obj_this.context.loading(1);
    $(".close_form_ghost").css("display","none");
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
        cancel_reason : obj_this.state.ro_reason,
        sales_return_id : obj_this.state.returnorder_id
      },
      type : "POST"
    }).done(function(return_data){
        console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          sale_returns:return_data.salesreturns,
          ro_reason: '',
          returnorder_id: ''
        },()=>{
          $(".salesreturn_page_container .single_so_container").css("height","75px").find(".arrow_down").css("transform","rotate(0deg)");
        });
        obj_this.context.loading(0);
        alert("Sales Return cancelled.")
      }else{
        obj_this.setState({
          ro_reason: '',
          returnorder_id: ''
        });
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.setState({
        ro_reason: '',
        returnorder_id: ''
      });
      alert("Network error");
    });

  }
  render(){
    const renderStatusBadge = (status) => {
      let bgColor = "#E2E8F0";
      let color = "#2D3748";
      let icon = "fa-info-circle";
      let text = status;

      if (status === 'REQ' || status?.toLowerCase() === 'requested') {
        bgColor = "#FEFCBF";
        color = "#975A16";
        icon = "fa-clipboard-list";
        text = "Requested";
      } else if (status === 'APR' || status === 'APP' || status?.toLowerCase() === 'approved') {
        bgColor = "#C6F6D5";
        color = "#22543D";
        icon = "fa-check-circle";
        text = "Approved";
      } else if (status === 'REJ' || status?.toLowerCase() === 'rejected') {
        bgColor = "#FED7D7";
        color = "#742A2A";
        icon = "fa-times-circle";
        text = "Rejected";
      } else if (status?.toLowerCase() === 'pending') {
        bgColor = "#BEE3F8";
        color = "#2A4365";
        icon = "fa-hourglass-start";
      } else if (status?.toLowerCase() === 'so confirmed') {
        bgColor = "#C4F1F9";
        color = "#086F83";
        icon = "fa-box";
      }

      return (
        <div className="so_delivery_date" style={{
          backgroundColor: bgColor,
          color: color,
          padding: "3px 8px",
          borderRadius: "12px",
          fontSize: "10px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: "5px"
        }}>
          <i className={`fa ${icon}`}></i> {text}
        </div>
      );
    };

  return (
    <MyContext.Consumer>
      {context => (
        <div className="salesreturn_page_container noselect">
          <div className="header_spacer"></div>
          <div className="sales_orders_container uijs swipemenu">
            <div className="page_header">
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Return Orders</div>
              <Link className="new_sales_order_button" 
                to="/salesreturn/new"
                style={{visibility:this.context.user_details.place_order?"visible":"hidden"}}
              > <i className="fa fa-plus plus_icon"></i> New</Link>
            </div>

            <div className="toggles_container">
              {/* <div className="list_1 toggles" menu="0">
                <i className="fa fa-clipboard-list order_status_icon"></i>
                <div className="order_status">Requested</div>
                <div className="order_count">{this.state.req_returnorders.length}</div>
              </div>
              <div className="list_2 toggles" menu="1">
                <i className="fa fa-hourglass-start order_status_icon"></i>
                <div className="order_status">Pending</div>
                <div className="order_count">{this.state.pend_returnorders.length}</div>
              </div>
              <div className="list_3 toggles" menu="2">
                <i className="fa fa-box order_status_icon"></i>
                <div className="order_status">SO Confirmed</div>
                <div className="order_count">{this.state.so_confirmed_returnorders.length}</div>
              </div>
              <div className="list_4 toggles" menu="3">
                <i className="fa fa-check-circle order_status_icon"></i>
                <div className="order_status">Placed</div>
                <div className="order_count">{this.state.sale_returns.length}</div>
              </div> */}
            </div>

            <div className="list_blocks_container">
              <div className="lists_container">
                <InfiniteScroll
                  dataLength={ this.state.sale_returns.length }
                  refreshFunction={this.fetchReturnOrders}
                  pullDownToRefresh
                  pullDownToRefreshThreshold={200}
                  pullDownToRefreshContent={
                    <h3 style={{ textAlign: 'center' , top : '50px'}}>&#8595; Pull down to refresh</h3>
                  }
                  releaseToRefreshContent={
                    <div className="loading_container" style={{ textAlign: 'center' , top : '100px'}} >
                      <div className="loading_symbol">
                        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                        width="40px" height="40px" viewBox="0 0 50 50" style={{enableBackground:'new 0 0 50 50'}}>
                          <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                             {/*<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.5s" repeatCount="indefinite"/>*/}
                          </path>
                        </svg>
                      </div>
                    </div>
                  }
                  >
                  {this.state.sale_returns.map((item,idx)=>(
                    <div className="single_so_container" key={idx}>
                      <div className="so_details_container">
                        <div style={{ width: "100%" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                            <div className="so_return_no">#{item.sales_return_no}</div>
                            {renderStatusBadge(item.status)}
                          </div>
                          <div className="so_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                          <div className="so_order_date">Return date : {item.return_date}</div>
                        </div>
                        {/* <div className="so_approve_button"
                          returnorder_id = {item.id}
                          style={{visibility:item.status=='REQ'?"visible":"hidden"}}
                        >
                          <i className="fas fa-check"></i>
                        </div> */}
                        <div className="so_edit_button" 
                          returnorder_id={item.id}
                           style={{display:item.status=='REQ'?"block":"none"}}
                        >
                          <i className="fa fa-pencil-alt"></i>
                        </div>
                        <div className="asm_reject_button"
                          returnorder_id = {item.id}
                           style={{display:item.status=='REQ'?"block":"none"}}
                        >
                          <i className="fas fa-times"></i>
                        </div>
                        
                        <div className="so_products_button">
                          <FiChevronDown className="arrow_down" />
                        </div>
                      </div>
                      <table className={`so_products_container ${context.magnified ? 'app-magnified-table' : ''}`} style={{display:item.products.length?"table":"none"}}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th >Qty</th>
                            <th>Unit</th>
                            <th align="center">UP</th>
                            <th align="center">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                        {item.products.map((product,index) => (
                          <tr key={index}>
                            <td valign="top">{index+1}</td>
                            <td valign="top">{product.product_specification == null || product.product_specification == ""?product.name:product.name+"/"+product.product_specification }</td>
                            <td valign="top">{product.return_qty}</td>
                            <td valign="top">{product.unit}</td>
                            <td valign="top" align="right">{product.unit_price}</td>
                            <td align="right" valign="top">{product.total}</td>
                          </tr>
                        ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="4" align="center">Total :</th>
                            <th colSpan ="2" align="right">{parseFloat(item.products.reduce((total, product) => total + parseFloat(product.total), 0)).toFixed(3)}</th>
                          </tr>
                          {/*<tr style={{display:item.tax?"table-row":"none"}}>
                            <th colSpan="5" align="right">Tax : </th>
                            <th align="right" align="right">{item.tax}</th>
                          </tr>
                          <tr style={{display:item.grand_total?"table-row":"none",fontSize : "12px",color : "#ea8000"}}>
                            <th colSpan="5" align="right">Grand Total ({this.context.currency}) :</th>
                            <th align="right" align="right">{item.grand_total}</th>
                          </tr>*/}
                        </tfoot>
                      </table>
  
                    </div>
                  ))}
                </InfiniteScroll>
              </div>
            </div>
            <div className="close_form_ghost">
              <form className="close_form" onSubmit={this.formSubmit} method="post">
                <i className="close_button fas fa-times"></i>
                <div className="input_label">Reason</div>
                <textarea className="custom_input ro_reason"
                  name="ro_reason"
                  value={this.state.ro_reason}
                  onChange={this.formChange}
                  required  
                />
                <button className="confirm_reject_button">CONFIRM</button>
              </form>
            </div>
            
          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default ReturnOrders;
ReturnOrders.contextType = MyContext;